export default {
    methods: {
        showDefaultSuccessMessage(message, autoClose = true, title = 'Good job!') {
            this.$swal({
                title: 'Good job!',
                text: message,
                icon: 'success',
                timer: autoClose ? 1300 : null,
                allowOutsideClick: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        },

        handleBackendError(e) {
            if (e.response) {
                if (e.response.data instanceof Object && e.response.data.detail) {
                    this.$swal({
                        title: e.response.data.title,
                        text: e.response.data.detail,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        showClass: {
                            popup: 'animate__animated animate__shakeX',
                        },
                        buttonsStyling: false,
                    });
                } else if (e.response.status === 422 && e.response.data instanceof Array) {
                    this.$swal({
                        title: this.$t('Component(Text):validation-failed'),
                        html: '<ul class="list-unstyled">' + e.response.data.map(violation => '<li class="text-left">' + violation.message + '</li>').join('') + '</ul>',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        showClass: {
                            popup: 'animate__animated animate__shakeX',
                        },
                        buttonsStyling: false,
                    });
                } else if (e.response.status === 404) {
                    this.$swal({
                        title: 'Requested resource not found',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        showClass: {
                            popup: 'animate__animated animate__shakeX',
                        },
                        buttonsStyling: false,
                    });
                }
            }
        },

        showViolationErrors(violations) {
            this.$swal({
                title: this.$t('Component(Text):validation-failed'),
                html: '<ul class="list-unstyled">' + violations.map(violation => '<li class="text-left">' + violation.message + '</li>').join('') + '</ul>',
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                showClass: {
                    popup: 'animate__animated animate__shakeX',
                },
                buttonsStyling: false,
            });
        },

        isValidationError(e) {
            return e.response.status === 422 && e.response.data instanceof Array;
        },

        getViolationsWithCodes(e, codes) {
            if (this.isValidationError(e)) {
                return e.response.data
                    .filter(violation => codes.includes(violation.code))
                    .map(violation => violation.message);
            }

            return null;
        },
    }
};
